"use client";

import { c as _c } from "react/compiler-runtime";
import { ApolloProvider } from "@apollo/client";
import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { SnackbarProvider } from "notistack";
import React, { type ReactNode } from "react";
import { apolloClient } from "#/graphql/apolloClient";
import { TrpcProvider } from "#/shared/trpc/TrpcProvider";
import { SnackbarCloseButton } from "#/shared/ui/atoms/SnackbarCloseButton";
import { StateThemeProvider } from "#/shared/ui/providers/StateThemeProvider";
import { isSnackbarClosable } from "#/shared/ui/snackbarClosability";
import { ReduxProvider } from "#/store/provider";
import type { SsrDeviceType } from "#/themes";
type AppShellProvidersProps = {
  children: ReactNode;
  session: Session | null;
  ssrDeviceType?: SsrDeviceType;
};

/**
 * Shared client provider stack for Pages `_app` and App Router layouts.
 * Locale/i18n and router-specific cache wrappers stay outside this tree.
 */
export const AppShellProviders: React.FC<AppShellProvidersProps> = t0 => {
  const $ = _c(9);
  const {
    children,
    session,
    ssrDeviceType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      containerAnchorOriginBottomLeft: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomCenter: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomRight: "snackbar-mobile-bottom-margin"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <SnackbarProvider maxSnack={4} action={_temp} classes={t1}>{children}</SnackbarProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== ssrDeviceType || $[4] !== t2) {
    t3 = <ApolloProvider client={apolloClient}><StateThemeProvider ssrDeviceType={ssrDeviceType}>{t2}</StateThemeProvider></ApolloProvider>;
    $[3] = ssrDeviceType;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== session || $[7] !== t3) {
    t4 = <TrpcProvider><ReduxProvider><SessionProvider session={session}>{t3}</SessionProvider></ReduxProvider></TrpcProvider>;
    $[6] = session;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(snackbarKey) {
  return isSnackbarClosable(snackbarKey) ? <SnackbarCloseButton snackbarKey={snackbarKey} /> : null;
}